import axios from "axios";

function get(url, data,responseType="") {
    return axios.get(`${url}`, {data,responseType});
}
function post(url, data) {
    return axios.post(`${url}`, request_interceptors(data));
}
function deleted(url) {
    return axios.delete(`${url}`);
}
function put(url, data) {
    return axios.put(`${url}`, data);
}




function request_interceptors (data) {
    if (localStorage.getItem('pre_defined_range_label') && data) {
        data.pre_defined_range_label = localStorage.getItem('pre_defined_range_label');
    }
    return data;
}
export  { get, post,deleted, put };
